<ng-container *ngIf='settings$ | async as settings'>
  <div class='columns p-sm is-flex-direction-column space-y-sm'>
    <div class='column is-12'>
      <h1>{{event?.title}}</h1>
      <a (click)="copyLink($event)" href="">Copy event link</a>
      </div>
    <div class='column is-12'>
      <label>Fullscreen</label>
      <mat-slide-toggle [ngModel]='eventService.isFullScreen$ | async' name='fullScreen'
                        (change)='!$event.checked ? eventService.exitFullscreen() : eventService.enterFullscreen()'>
        {{ (eventService.isFullScreen$ | async) ? 'Exit' : 'Enter' }} Fullscreen
      </mat-slide-toggle>


    </div>
    <div class='column is-12'>
      <label>Theme</label>
      <mat-button-toggle-group name='Theme' aria-label='Font Style' [(ngModel)]='settings.theme' [value]="settings.theme" (change)="setTheme($event.value)">
        <mat-button-toggle value='light'>Light Theme</mat-button-toggle>
        <mat-button-toggle value='dark'>Dark Theme</mat-button-toggle>
      </mat-button-toggle-group>

    </div>

    <div class='column is-12'>
      <label>Font</label>    
        <app-dropdown
          [options]="fonts"
          [ngModel]="fontFamily"
          (onValueChanged)='updateFont($event)'
        ></app-dropdown>
    </div>

    <div class="column is-12">
      <app-text-field [value]="settings.fontSize" type="number" (onChange)="updateFontSize($event.target.value)" label="Font Size"></app-text-field>
    </div>
    <div class="column is-12">
      <label>Background</label>
      <p-colorPicker [(ngModel)]="settings.background" (onChange)="updateBackground($event.value)"></p-colorPicker>
    </div>
    <div class="column is-12">
      <label>Text Color</label>
      <p-colorPicker [(ngModel)]="settings.textColor" (onChange)="updateTextColor($event.value)"></p-colorPicker>
    </div>
    <div class='column is-12'>

      <label>Language</label>
      <mat-form-field class='example-full-width'>
        <input type='text'
               placeholder='Pick one'
               aria-label='Number'
               matInput
               [formControl]='lang'
               [matAutocomplete]='langAuto'>
        <mat-autocomplete #langAuto='matAutocomplete' [displayWith]='displayFn'
                          (optionSelected)='languageChanged($event.option)'>
          <mat-option *ngFor='let option of (filteredOptions | async)' [value]='option'>
            {{option.label}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div class='column is-12'>
      <label>Split Screen</label>
      <mat-slide-toggle [ngModel]='eventService.isSplitScreen$ | async' name='splitScreen'
                        (change)='closeMenu.emit(); $event.checked ? eventService.enterSplitScreen() : eventService.exitSplitScreen()'>
        {{ (eventService.isSplitScreen$ | async) ? 'Exit' : 'Enter' }} Split Screen
      </mat-slide-toggle>
    </div>

  </div>

</ng-container>
